import * as React from 'react';

import ActivityNoteTemplate from './activityNoteTemplate';
import ActivityTemplate from './activityTemplate';
import WorkkardNote from './workkardNote';
import WorkkardLog from './workkardLog';
import ActivityLog from './activityLog';
import WorkkardActionHistory from './workkardActionHistoryTemplate';
import ActivityActionHistory from './activityActionHistoryTemplate';
import WorkkardTemplate from './workkardTemplate';
import WorkkardFilesTemplate from "./workkardFilesTemplate";
import ActivityFilesTemplate from "./activityFilesTemplate";
import { CombinedViewConstants } from "../constants";


/**
 * Renders one timeline entry.
 *
 * The dispatch used to be more involved: the server nested attachments inside
 * the note and action rows that owned them, so selecting "Files" alone still
 * returned the parent row and this component had to decide whether to draw the
 * full card or only its attachments. Attachments are now their own entry types,
 * and the server sends only the types that were asked for, so each entry maps
 * to exactly one template.
 */
export default function CombineViewCell({ data, extraData }) {
    const { workkardId, isPrintPreview = false } = extraData;

    switch (data.type) {
        case CombinedViewConstants.entryType.workkard:
            return <WorkkardTemplate data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.workkardNote:
            return <WorkkardNote data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.workkardLog:
            return <WorkkardLog data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.workkardActionHistory:
            return <WorkkardActionHistory data={data} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.workkardFile:
            return <WorkkardFilesTemplate data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.activity:
            return <ActivityTemplate data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.activityNote:
            return <ActivityNoteTemplate data={data} workkardId={workkardId} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.activityLog:
            return <ActivityLog data={data} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.activityActionHistory:
            return <ActivityActionHistory data={data} isPrintPreview={isPrintPreview}/>
        case CombinedViewConstants.entryType.activityFile:
            return <ActivityFilesTemplate data={data} isPrintPreview={isPrintPreview}/>
        default:
            return null;
    }
}